import {CustomEventsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

/**
 * Log a URL redirect in the Devour event system before doing the actual redirect.
 * @param url - The URL to log
 * @param blankPage - If true, opens in new tab (only if skipOpen is false)
 * @param skipOpen - If true, only logs the event without opening the URL
 */
export async function logClickUrlEvent(url: string, blankPage?: boolean, skipOpen?: boolean): Promise<void> {
    let redirectUrl = url; // Fallback to original URL if logging fails

    try {
        const res = await new CustomEventsApi(getConfig()).getEventsCustomUrl({
            url,
        });
        redirectUrl = res.redirectUrl || url;
    } catch {
        // Silently fail - analytics should not block user actions
    }

    if (skipOpen) {
        return; // Only log, don't open
    }

    if (blankPage) {
        window.open(redirectUrl, "_blank", "noopener,noreferrer");
    } else {
        window.location.href = redirectUrl;
    }
}
